export default "__VITE_ASSET__7ea5e3de__"